import cloudflare from './cloudflare';
import firebase from './firebase';
import firebaseAdminService from './firebase-admin';

export default {
  failed: 'Action failed',
  success: 'Action was successful',
  update: 'Update',

  error: {
    undefined: 'Undefined error occurred',
    validator: {
      mandatory: 'Mandatory field',
      email: 'Not a valid email format.',
      length: 'Length must between {min} and {max}',
      range: 'Range must between {min} and {max}',
      notDate: 'Not a date.',
      match: 'Field not match: {field}',
      regex: 'Regex not match: {regex}',
      qTelInput: {
        INVALID_COUNTRY: 'Invalid Country',
        NOT_A_NUMBER: 'Input is not a phone number',
        TOO_SHORT: 'Value is too short',
        INVALID: 'Value is invalid',
        ANOTHER_COUNTRY: 'Country in dropdown differs from parsed',
      },
    },
    type: {
      undefined: 'Unknown error',
      GENERIC_ERROR: 'Generic backend error',
      VALIDATION_ERROR: 'Validation error',
    },
    errorCode: {
      ...firebase,
      ...cloudflare,
      ...firebaseAdminService,
    },
  },

  menu: {
    invite: 'Invite',
    users: 'Users',
    profile: 'Profile',
    matchbox: 'MatchBox',
    logout: 'Log out',
  },

  breadcrumb: {
    matchbox: {
      main: 'MatchBox',
      tiles: 'Tiles',
      master: {
        main: 'Master',
        palette: 'Color Palette',
        series: 'Series',
        masterData: 'Master Data',
        tires: 'Tires',
      },
    },
  },

  common: {
    password: 'Password',
    submit: 'Submit',
    login: 'Login',
    send: 'Send',
    email: 'Email',
    ok: 'OK',
    cancel: 'Cancel',
    no: 'No',
    yes: 'Yes',
    save: 'Save',
    load: 'Load',
    confirm: 'Confirm',
    close: 'Close',
  },

  docNote: {
    INFO: 'Information',
    TIP: 'Tip',
    WARNING: 'WARNING',
    ERROR: 'Error',
  },

  component: {
    profile: {
      name: 'Name',
      email: 'Email',
      photoUrl: 'Photo URL',
    },
  },

  login: {
    email: 'Usernam or email',
  },

  invite: {
    header: 'Invite administrator',
    body: "Register a new administrator. We will send notification email as well to verify its identity. Don't forget to ask client certificate as well.",
  },

  firebaseAdmin: {
    users: {
      table: {
        header: {
          actions: 'Actions',
        },
      },
      editDialog: {
        title: 'Edit user',
        label: {
          displayName: 'Display Name',
          email: 'Email',
          role: 'Role',
          isDisabled: 'Is the user disabled?',
        },
      },
    },
  },

  profile: {
    tabs: {
      myProfile: 'My Profile',
      changePassword: 'Change Password',
      verifyEmail: 'Verify Email',
    },
    verifyEmail: {
      verifyButtonLabel: 'Verify',
      successMessage:
        'We have sent you a verification email to: {email}. Please follow the instructions in the email to continue.',
    },
    changePassword: {
      oldPasswordLabel: 'Old Password',
      newPasswordLabel: 'New Password',
      confirmPasswordLabel: 'Confirm Password',
      passwordStrengthMessage: 'Your password is {strength}',
      message: {
        tooWeak: 'Too weak new password',
      },
      docNote: {
        p1: {
          text: 'This is an administrative page, therefore strong password usage is expected. Please choose your future password considering the following rules. It is recommended to use a password manager system.',
          rules: {
            length: 'The length must be at least 15 character',
            letter: 'Must contains at least one uppercase letter',
            number: 'Must contains at least one number',
            special:
              "Must contains at least one special character [# {'@'} ? , . ! + ~]",
            strong: "The password strenght have to be at least 'safe'",
          },
        },

        p2: {
          text: 'Here are some popular password manager solutions, mainly from free solutions',
          keepass:
            'KeePass: An open-source password manager that can be used offline.',
          lastpass:
            'LastPass: Has a free version that offers cloud-based storage.',
          bitwarden:
            'Bitwarden: An open-source solution with free and premium options.',
          dashlane:
            'Dashlane: Free version suitable for a limited number of password storage.',
          zoho: 'Zoho Vault: Free version for businesses that also allows password sharing.',
          nordpass: 'NordPass: Free basic version that offers secure storage.',
        },
      },
      strength: {
        risky: 'risky',
        guessable: 'guessable',
        weak: 'weak',
        safe: 'safe',
        secure: 'secure',
      },
    },
  },
};
